$(() => {
  const listing_upload_input = $('#listing-image-upload-input');
  const event_upload_input = $('#event-image-upload-input');

  // only run this on pages that have an upload input
  if (listing_upload_input.length > 0 || event_upload_input.length > 0) {
    const upload_input = listing_upload_input[0]
      ? listing_upload_input
      : event_upload_input;

    const remove_image = $('.remove-listing-image');
    const image_container = $('.featured-image-container');
    const placeholder = $('svg.placeholder');

    const handleImageUpload = () => {
      const image = upload_input[0].files[0];

      // Hide placeholder SVG
      placeholder.css('display', 'none');
      // Remove no-image class from image container
      image_container.removeClass('no-image');
      // Add background-image to image container
      image_container.css(
        'background-image',
        `url('${URL.createObjectURL(image)}')`
      );
      // Show `remove` button underneath image
      remove_image.removeClass('hidden');
    };

    // Remove photo
    const handleRemovePhoto = () => {
      remove_image.addClass('hidden');
      image_container.css('background-image', '');
      placeholder.css('display', 'block');
      upload_input.val(null);
    };

    // Populate image if files is found
    if (upload_input[0].files.length) {
      handleImageUpload();
    }

    // Handle image change
    upload_input.change(handleImageUpload);

    // Remove image on click
    remove_image.click(handleRemovePhoto);

    $('#clear_from_return').click(() => {
      handleRemovePhoto();
    });
  }
});
